import { fetcher } from "helpers/fetcher";

import { TRemoveBUMemberReq, TRemoveBUMemberRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const removeBUMember = async (payload: TRemoveBUMemberReq) => {
  return await fetcher<TRemoveBUMemberRes, TRemoveBUMemberReq["data"]>(
    ENDPOINT.BU.REMOVE_BU_MEMBER,
    {
      data: payload.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.BU.REMOVE_BU_MEMBER.version,
        [API_HEADER.BU_ID]: payload.idBu,
      },
    }
  );
};

export const mutationRemoveBUMember = async (payload: TRemoveBUMemberReq) => {
  return (await removeBUMember(payload)).data;
};

mutationRemoveBUMember._key = (payload: TRemoveBUMemberReq) => [
  ENDPOINT.BU.REMOVE_BU_MEMBER.url,
  payload,
];
